export default {
  'app.pwa.offline': 'Вы сейчас не в сети',
  'app.pwa.serviceworker.updated': 'Доступно новое содержимое',
  'app.pwa.serviceworker.updated.hint': 'Пожалуйста, нажмите кнопку "Обновить" для перезагрузки текущей страницы',
  'app.pwa.serviceworker.updated.ok': 'Обновить',
};
